const punc = [
  "。","？","！","，","、","；","：","“","”","‘","’","（","）","【","】","{","}","——",
  "…","．","《","》","〈","〉","·","—","_","/",".","?","!",",",":",";","-","–","—",
  "(",")","[","]","\"","'"
]

export default punc;